module.exports = __webpack_public_path__ + "static/media/workforce.016797a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/workforce.png
// module id = 3536
// module chunks = 3